import { Patient } from "@medplum/fhirtypes";

/**
 * Checks whether a Patient should replace the Patient on screen.
 * @param updated - Patient returned by a newer read or write.
 * @param current - Patient currently held by the chart, if any.
 * @returns True when `updated` is the same Patient and was last updated after `current`, or when
 * `current` has no `lastUpdated`.
 */
export function isNewerVersion(updated: Patient, current: Patient | undefined): boolean {
  if (!current || current.id !== updated.id) return false;
  const currentLastUpdated = current.meta?.lastUpdated;
  if (!currentLastUpdated) return true;
  const updatedLastUpdated = updated.meta?.lastUpdated;
  if (!updatedLastUpdated) return false;
  return new Date(updatedLastUpdated).getTime() > new Date(currentLastUpdated).getTime();
}
